const pathBase = "/users";

export const usersPath = () => pathBase;

export const userPath = (id?: number | string) =>
  id ? `${pathBase}/${id}` : null;

export const userCorrespondencePath = (id?: number | string) =>
  id ? `${pathBase}/${id}/correspondence` : null;
